import http from "../http-common";
import authHeader from "./auth-header";

const API_URL = '/periodolectivo';
//put /api//periodolectivo/{id]/estado

class PeriodoService {
  getAll() {
    return http.get(API_URL, { headers: authHeader() });
  }

  getActivo() {
    return http.get(`${API_URL}/activo`, { headers: authHeader() });
  }

  update(id, data) {
    return http.put(`${API_URL}/${id}/estado`, data, { headers: authHeader() });
  }

  // Método para activar/desactivar un período
  async togglePeriodo(id, estado) {
    try {
      // Solo enviamos el campo estado
      const estadoData = {
        estado: estado
      };
      
      return await this.update(id, estadoData);
    } catch (error) {
      console.error('Error al actualizar el estado del período:', error);
      throw error;
    }
  }
}

export default new PeriodoService();
